import { Loader } from '@/components/Loader';
import type { WithChildren } from '@/lib/types';
import { useConfigProvider } from '@/providers/ConfigProvider';

export const RestoreCheckoutInitializer = ({ children }: WithChildren) => {
  const { restoreCheckoutInitialized } = useConfigProvider();
  if (!restoreCheckoutInitialized) {
    return (
      <Loader data-testid='RestoreCheckoutInitializerLoader' height={400} />
    );
  }

  return <div data-testid='RestoreCheckoutInitializer'>{children}</div>;
};
